import { SET_CUSTOMERS_VERSIONS_WS, SET_CUSTOMERS_VERSIONS } from './chunk-S5MTJL4K.mjs';
import { produce } from 'immer';

var CUSTOMERS_VERSIONS_INITIAL_STATE = {
  master: 0,
  location: 0,
  remoteLocation: null
};
var customersVersionsReducer = produce((state = CUSTOMERS_VERSIONS_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CUSTOMERS_VERSIONS:
    case SET_CUSTOMERS_VERSIONS_WS:
      return action.payload;
    default:
      return state;
  }
});
var reducers_default = customersVersionsReducer;

export { CUSTOMERS_VERSIONS_INITIAL_STATE, reducers_default };
